// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"83f98ff8","389":"83f98ff8","547":"83f98ff8","581":"83f98ff8","865":"83f98ff8","868":"83f98ff8"}[chunkId] + ".chunk.css";
};